import {
  all, call, put, take,
} from 'redux-saga/effects';
import { find, map } from 'lodash/fp';
import * as errorActions from '../../errors/actions';

import * as contactServices from '../contact/services';
import * as actions from './actions';

export function* fetchGuardianContactsByUser() {
  while (true) {
    try {
      yield take(actions.FETCH_GUARDIAN_CONTACTS_BY_USER_REQUEST);

      const { data: guardianContacts } = yield call(contactServices.fetchGuardianContactsByUser);

      const responses = yield all(map((guardianContact) => call(contactServices.fetchContact, { cid: guardianContact.contact.id }), guardianContacts));

      const children = map((response) => response.data, responses);

      yield put(actions.fetchGuardianContactsByUserSuccess({
        guardianContacts: map((guardianContact) => ({
          ...guardianContact,
          contact: find((child) => child.id === guardianContact.contact.id, children),
        }), guardianContacts),
      }));
    } catch (error) {
      yield put(actions.fetchGuardianContactsByUserFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}
